<template>
    <div class="header-section">
        <h1 class="form-title">Tournament Details</h1>
        <p class="form-subtitle">Set up tournjament and add the required details</p>
    </div>
    <form @submit.prevent="submitForm">
        <div class="setup-form">
            <div class="header">
                <div class="form-group">
                    <label for="tournamentName">Competition/Tournament Name</label>
                    <input type="text" placeholder="Enter tournament name" required />
                </div>
                <div class="form-group">
                    <label for="location">Start Date</label>
                    <input type="date" placeholder="Select start date" required />
                </div>
                <div class="form-group">
                    <label for="location">Likely End Date</label>
                    <input type="date" placeholder="Select start date" required />
                </div>
                <div class="form-group">
                    <label for="playingTime">Playing Time</label>
                    <input type="datetime-local" id="playingTime" name="playingTime" required />
                </div>

                <div class="form-group">
                    <label for="slots">No. of Slots</label>
                    <input type="number" id="slots" name="slots" min="1" placeholder="Enter number of slots" required />
                </div>
            </div>
            <div class="header">
                <div class="form-group">
                    <label for="tournamentName">Type of Tournament</label>
                    <select id="tournamentName" required>
                        <option value="">Select Tournament Type</option>
                        <option value="knockout">Knockout</option>
                        <option value="round-robin">Round Robin</option>
                        <option value="league">League</option>
                        <option value="friendly">Friendly</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="playerCategory">Categories of Players</label>
                    <select id="playerCategory" required>
                        <option value="">Select Player Category</option>
                        <option value="junior">Junior</option>
                        <option value="senior">Senior</option>
                        <option value="mixed">Mixed</option>
                        <option value="open">Open</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="tournamentName">Name of Player</label>
                    <input type="text" placeholder="Name of player" required />
                </div>
                <div class="form-group">
                    <label for="location">Any other Considerations</label>
                    <textarea placeholder="Type your message here..." rows="8" required />
                </div>
            </div>
        </div>
        <!-- File Upload Section -->
        <p style="color: #232321; font-weight: 600; font-size: 16px; text-align: center;">Product Gallery</p>
        <div @click="triggerFileInput" class="upload-section">
            <!-- Hidden input -->
            <input type="file" ref="fileInput" class="hidden" accept="image/jpeg, image/png" multiple
                @change="handleFileChange" />

            <!-- Custom trigger -->
            <div>
                <Image size="32" style="margin-bottom: 10px;" />
                <p style="padding: 0%; margin: 0%;">Drop your imager here, or browse</p>
                <p style="padding: 0%; margin: 0%;">Jpeg, png are allowed</p>
            </div>
        </div>
        <!-- File list with progress -->
        <div class="file-list-section">
            <div class="file-item" v-for="file in files" :key="file.name">
                <img v-if="file.preview" :src="file.preview" alt="preview" class="file-preview" />

                <p class="file-name">
                    {{ file.name.replace(/\.[^/.]+$/, "") }}
                </p>
                <div class="progress-container">
                    <div class="progress-bar" :style="{ width: file.progress + '%' }"></div>
                </div>
                <CircleCheck v-if="file.progress === 100" style="color: #DB6813;" />
                <CircleCheck v-else style="color: #00000033;" />

            </div>
        </div>
        <div class="buttons">
            <button>Delete Tournament</button>
            <button>Upload Tournament</button>
        </div>
    </form>
</template>
<script setup>
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, reactive } from "vue";

const fileInput = ref(null);
const files = ref([]);

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFiles = Array.from(event.target.files);

    selectedFiles.forEach((file) => {
        const fileObj = reactive({
            name: file.name,
            progress: 0,
            uploading: true,
            preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null
        });
        files.value.push(fileObj);
        uploadFile(fileObj);
    });

    event.target.value = "";
}


function uploadFile(fileObj) {
    const interval = setInterval(() => {
        if (fileObj.progress < 100) {
            fileObj.progress += 10;
        } else {
            clearInterval(interval);
            fileObj.uploading = false;
        }
    }, 400);
}
</script>
<style scoped>
.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>